import { Component } from 'react'
import ReactCrop from 'react-image-crop'
import '!style-loader!css-loader!react-image-crop/dist/ReactCrop.css' // eslint-disable-line
import { convertImgToBase64URL } from 'utils/helpers'
import s from './PhotoCropper.scss'

class PhotoCropper extends Component {
  state = {
    src: null,
    aspect: 1 / 1,
    crop: {
      unit: '%',
      width: 30,
      height: 30
    }
  }

  componentDidMount() {
    const { photo, aspect } = this.props
    if (photo) {
      convertImgToBase64URL(photo, base64Img => {
        this.setState(prevState => ({
          src: base64Img,
          aspect: prevState.aspect,
          crop: {
            ...prevState.crop,
            width: 100
          }
        }))
      })
    }
    if (aspect) {
      this.updateAspectRatio(aspect)
    }
  }

  onSelectFile = e => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0]
      const reader = new FileReader()
      reader.addEventListener('load', () => {
        this.props.onFileChange(file)
        this.setState({ src: reader.result })
      })
      reader.readAsDataURL(e.target.files[0])
    }
  }

  onImageLoaded = e => {
    this.imageRef = e.currentTarget
  }

  onCropComplete = crop => {
    this.makeClientCrop(crop)
  }

  onCropChange = crop => {
    this.setState({ crop: { ...crop, x: Math.round(crop.x), y: Math.round(crop.y) } })
  }

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(this.imageRef, crop, 'newFile.jpeg')
      const cropData = this.getCropData(this.imageRef, crop)
      this.props.onCropComplete(cropData)
      this.setState({ croppedImageUrl })
    }
  }

  getCropData = (image, crop) => {
    const { x, y, width, height } = crop

    return {
      width: Math.round(this.getScaleX(image) * width),
      height: Math.round(this.getScaleY(image) * height),
      unit: 'px',
      x,
      y
    }
  }

  getScaleX = image => {
    const { naturalWidth, width } = image
    return naturalWidth / width
  }

  getScaleY = image => {
    const { naturalHeight, height } = image
    return naturalHeight / height
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement('canvas')
    const scaleX = this.getScaleX(image)
    const scaleY = this.getScaleY(image)
    canvas.width = crop.width
    canvas.height = crop.height
    const ctx = canvas.getContext('2d')

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    )

    return new Promise(resolve => {
      canvas.toBlob(blob => {
        if (!blob) {
          console.error('Canvas is empty')
          return
        }
        blob.name = fileName
        window.URL.revokeObjectURL(this.fileUrl)
        this.fileUrl = window.URL.createObjectURL(blob)
        resolve(this.fileUrl)
      }, 'image/jpeg')
    })
  }

  updateAspectRatio = aspect => {
    this.setState({ aspect })
  }

  render() {
    const { crop, croppedImageUrl, src, aspect } = this.state
    const { noPreview } = this.props

    return (
      <div className={s.cropperContainer}>
        <div>
          <input type="file" onChange={this.onSelectFile} accept="image/*" />
        </div>
        <div className={s.container}>
          <div className={s.image}>
            {src && (
              <ReactCrop
                crop={crop}
                aspect={aspect}
                onComplete={this.onCropComplete}
                onChange={this.onCropChange}
              >
                <img src={src} onLoad={this.onImageLoaded} />
              </ReactCrop>
            )}
          </div>
          {!noPreview && (
            <div className={s.preview}>
              {croppedImageUrl && <img alt="Crop" src={croppedImageUrl} />}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default PhotoCropper
